import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'

type ReportTotalConstructorArgs = ConstructorArgs<() => ReportTotal>

export class ReportTotal extends BaseRecord {
    readonly recordType = 'reporttotal'

    total?: number
    delta?: number
    totalString?: string
    deltaString?: string
    deltaTotal?: string
    count?: number

    constructor(data?: Partial<ReportTotalConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.total = this.propertyFromCurrencyArg(data.total)
        this.delta = this.propertyFromCurrencyArg(data.delta)
        this.totalString = data.total_string ?? undefined
        this.deltaString = data.delta_string ?? undefined
        this.deltaTotal = data.delta_total ?? undefined
        this.count = this.propertyFromIntArg(data.count)
    }

    clone(overrides?: Partial<ReportTotalConstructorArgs>): ReportTotal {
        return new ReportTotal({ ...this.serializeForClone(), ...overrides })
    }
}
